export const ChristmasTree = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 26H5L10.9574 18H6L13 10H9L15.5951 2L22 10H18L25.0091 18H20.0544L27 26Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<mask id="path-2-inside-1_1_7021" fill="white">
<rect x="12" y="25" width="8" height="5" rx="1"/>
</mask>
<rect x="12" y="25" width="8" height="5" rx="1" fill="currentColor" stroke="currentColor" stroke-width="4" mask="url(#path-2-inside-1_1_7021)"/>
</svg>`;
